import api from 'services/api'
import {SEARCH_OCCUPANTS} from '../endpoints'

export const searchOccupants = async (body) => await api.post(SEARCH_OCCUPANTS, body)
